import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { COOKIE } from '@/constants/testIds';

const KEY = 'cc_cookie_consent';

export const CookieBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          data-testid={COOKIE.banner}
          className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-black/80 p-5 backdrop-blur-xl shadow-2xl sm:flex sm:items-center sm:gap-5"
        >
          <div className="flex items-start gap-3">
            <Cookie className="mt-0.5 h-6 w-6 shrink-0 text-brand" />
            <p className="text-sm text-white/70">
              {t('cookie.text')}{' '}
              <Link to="/legal/cookies" className="text-brand hover:underline">{t('cookie.policyLink')}</Link>.
            </p>
          </div>
          <div className="mt-4 flex shrink-0 gap-3 sm:mt-0">
            <button onClick={() => decide('rejected')} data-testid={COOKIE.reject} className="btn-secondary px-5 py-2 text-sm">
              {t('cookie.reject')}
            </button>
            <button onClick={() => decide('accepted')} data-testid={COOKIE.accept} className="btn-primary px-5 py-2 text-sm">
              {t('cookie.accept')}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
